import { gql } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';

const DOWNLOAD_FILE_QUERY = gql`
  query ditDownloadFile($s3Bucket: String!, $s3FileKey: String!) {
    ditDownloadFile(s3Bucket: $s3Bucket, s3FileKey: $s3FileKey)
  }
`;

export const useDitFileDownload = () => {
  const [downloadFile] = useLazyQuery(DOWNLOAD_FILE_QUERY);

  const handleFileDownload = async (fileDetails, filename, setFileBuffer) => {
    const { data } = await downloadFile({ variables: fileDetails });
    const base64 = data.ditDownloadFile;
    const byteCharacters = atob(base64);
    const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);

    // only set the file buffer if a setter is provided
    // this is useful for cases where you want to handle the file differently
    // e.g. displaying the results in a viewer component
    if (setFileBuffer) {
      setFileBuffer(byteArray.buffer);
      return;
    }

    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return { handleFileDownload };
};
